<template>
  <div class="bg" style="padding: 20px 40px;box-sizing: border-box;">
    <div class="title">
    <div align="left" class="title-t">修改密码</div>
 
    <i class="el-icon-circle-close" style="font-size: 24px; line-height: 32px; color:#626626;cursor: pointer;" @click="closew"></i>  

   
   </div>
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="输入密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if(value.length < 6){
        callback(new Error("密码最少为 6 位数"));
        this.ruleForm.Pass = ""
      }
      else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
          console.log(this.$refs.ruleForm);
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" && this.ruleForm.pass == "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!请重新输入"));
        this.ruleForm.checkPass = ""
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      personId:""
    };
  },
  created(){
    this.getpersonId();
  },
  methods: {
    closew(){
    //  this.$router.go(-1);
      this.$router.push({
        path: "/Preson",
      });
    },
    getpersonId(){
      var info = JSON.parse(localStorage.getItem("uesrInfo"));
      this.personId = info.employee_id;
    },
    opensucess() {
          this.$message({
          message: '密码修改成功',
          type: 'success',
          duration:'1000'
    });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
          console.log(valid);
        if (valid) {
           console.log(this.ruleForm.pass);
        var sendPasswrod = {};
        sendPasswrod.employee_id = this.personId;
        sendPasswrod.password = this.ruleForm.pass;
        console.log(sendPasswrod);
        this.$http
        .post(IPConfig.IP + "/kpi-management/user/pwd.php",JSON.stringify(sendPasswrod))
        .then(
          function(res) {
          console.log(res);
          this.opensucess();
          // this.ruleForm.pass = ""
          // this.ruleForm.checkPass =""
          this.$router.push({
             path: "/"
           });

        
        },
          function(err) {}
        );
    
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style scope >
.bg{
 width: 600px;
 margin: 50px auto;
 text-align: center;
 padding-right: 80px !important; 
}
/* .el-form-item__content{
  margin-left:0 !important; 
} */
.title{
    display: flex;
    justify-content: space-between;
    margin: 10px 0 60px 30px;
}
.title-t{
    font-size: 24px;
    font-weight: 600;
}

</style>




// WEBPACK FOOTER //
// src/components/a-changepasswrod.vue